import React from 'react';
import CustomChip from '../../../../common/customChip/CustomChip';
import UserIcon from "assets/img/svg/svgComponents/UserIcon";
import BankIcon from "assets/img/svg/svgComponents/BankIcon";
import PencilIcon from "assets/img/svg/svgComponents/PencilIcon";
import styles from "./styles.module.scss";
import bankLogo from "assets/img/icons/common/bankLogo.png";
import { bankStatusChipInfo, bankStatusChipStyle, beneficiaryTypeChipStyles } from './utils';

const BankDetailsCard = ({
    accountDetails = {},
    iconClickHandler = () => {},
    openDetailsDialogIcon = null,
    showBeneficiaryTypeChip = false,
    highlightCardBorder = false
}) => {

    const { accountNumber, bankStatus, beneficiaryName, accountType, bankKey, beneficiaryType} = accountDetails;

    return (
        <div className={`d-flex flex-column justify-content-between ${styles['bank-details-card']} ${highlightCardBorder ? styles['border-black'] : ''}`}>

            <div className='d-flex justify-content-between'>
                <div className={styles['bank-icon']}><img src={bankLogo} alt="bank_logo" /></div>
                {showBeneficiaryTypeChip //todoRefactor
                ? <CustomChip text={beneficiaryType} style={beneficiaryTypeChipStyles} />
                : <CustomChip {...bankStatusChipInfo[bankStatus]} style={bankStatusChipStyle} />
                }
            </div>

            <div className={styles['account-no']}>{accountNumber}</div>

            <div className='d-flex justify-content-between'>
                <div className={`${styles['bank-details']}`}>
                    <div>
                        <UserIcon />
                        <span className='ml-1'>{beneficiaryName} • </span>
                        <span>{accountType}</span>
                    </div>

                    <div>
                        <BankIcon />
                        <span className='ml-1'>{bankKey}</span>
                        {/* <span>EFT</span> */}
                    </div>

                </div>

                {openDetailsDialogIcon && 
                <span
                    className={styles['edit-icon-wrapper'] + " cursor"}
                    onClick={() => iconClickHandler(accountDetails)}
                >
                    {openDetailsDialogIcon}
                </span>
                 }
            </div>


        </div>
    );
}

export default BankDetailsCard;